
import Vue from "vue";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";
import { ClientPortalConfig } from "@/models/dossier-configs/client-portal";
import {SaleType} from "@/models/base";
import {SaleService} from "@/services";
import {ClientPortalTabConfig} from "@/models/dossier-configs/client-portal-tab-config";
import {CustomTranslation} from "@/utils/custom-translation";
import AppTranslationInput from "@/components/TranslationInput.vue";
import { v4 } from "uuid";

export default Vue.extend({
	data() {
		return {
			TypeID: 0 as Number,
			saleTypes: [] as SaleType[],
			toEditClientPortalTabConfig: null as ClientPortalTabConfig | null
		};
	},
	props: {
		config: {
			type: Object as ()=>ClientPortalConfig,
			required: true
		}
	},
	computed: {
		showEditModal(){
			return this.toEditClientPortalTabConfig != null;
		}
	},
	methods: {
		addType(){
			let t = this.saleTypes.filter((t:SaleType) => t.ID == this.TypeID)[0] as SaleType;
			let c = new ClientPortalTabConfig({
				Name: new CustomTranslation({Translations: {"nl-be": t.getDisplayedName(this.$i18n.locale),"FallBack": t.getDisplayedName(this.$i18n.locale)}}),
				Deletable: true,
				Visible: true,
				Position: 3,
				ID: v4(),
				TypeID: t.ID
			});
			this.config.ClientPortalTabConfigs.push(c);
			this.config.ShownSaleTypeIDs.push(t.ID);
		},
		deleteTab(i:number){
			let t = this.config.ClientPortalTabConfigs[i] as ClientPortalTabConfig;
			this.config.ClientPortalTabConfigs.splice(i, 1);
			if(t.TypeID!==1 && t.TypeID!==2){
				this.config.ShownSaleTypeIDs = this.config.ShownSaleTypeIDs.filter(value => value !== t.TypeID);
			}
		},
		editTab(t:number){
			this.toEditClientPortalTabConfig = this.config.ClientPortalTabConfigs[t];
		},
		save(){
			this.$emit("save");
		}
	},
	mounted(){
		this.saleTypes = SaleService.getAllTypes();
	},
	components: {
		AppSaleTypeSelect,
		AppTranslationInput
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
